import format from 'date-fns/format';

const shortMonth = date => format(date, 'MMM yyyy');
const longMonth = date => format(date, 'MMMM yyyy');
const shortMonthDateString = date => format(date, 'dd MMM yyy');
const fullMonthDateString = date => format(date, 'dd MMMM yyy');
const fullDateFormat = date => format(date, 'yyyy-MM-dd');
const fullTimeDateFormat = date => new Date(date).toISOString();
const birthDateFormat = date => format(date, 'dd/MM/yyyy');

const startOfMonth = date => {
  date.setDate(1);
  return date;
};

const endOfMonth = date => {
  date.setDate(28);
  return date;
};

const changeDateByYearsAndMonths = (date, years, months) => {
  const dateChangedYear = new Date(date.setFullYear(date.getFullYear() + years));
  return new Date(dateChangedYear.setMonth(dateChangedYear.getMonth() - months));
};

export {
  shortMonth,
  longMonth,
  startOfMonth,
  endOfMonth,
  fullDateFormat,
  fullTimeDateFormat,
  shortMonthDateString,
  fullMonthDateString,
  birthDateFormat,
  changeDateByYearsAndMonths,
};
